import { buildFnolApiUrl, getFnolApiBaseCandidates } from './fnolApi';

export const hasKnownVoiceRecording = (...ids) =>
  ids.some(Boolean);

const buildContentUrl = (baseUrl, recordId, recording) => {
  const objectPath = typeof recording === 'string' ? recording : recording?.object_path;
  const url = new URL(`/fnol-records/${encodeURIComponent(recordId)}/voice-recordings/content`, baseUrl);
  url.searchParams.set('object_path', objectPath);
  const version = typeof recording === 'string' ? '' : recording?.updated || recording?.size;
  if (version) url.searchParams.set('v', String(version));
  return url.toString();
};

const getErrorMessage = async (response) => {
  try {
    const data = await response.clone().json();
    const detail = data.detail || data.details || data.error || data.message || '';
    return typeof detail === 'string' ? detail : JSON.stringify(detail);
  } catch {
    return '';
  }
};

export const fetchFnolVoiceRecordings = async (recordId) => {
  const path = `/fnol-records/${encodeURIComponent(recordId)}/voice-recordings`;
  let lastError = null;
  let response = null;

  for (const base of getFnolApiBaseCandidates()) {
    try {
      const result = await fetch(buildFnolApiUrl(path, base));
      if (result.ok) {
        response = result;
        break;
      }

      const message = await getErrorMessage(result);
      const error = new Error(message || `Request failed (${result.status})`);
      if (result.status === 403) throw error;
      lastError = error;
    } catch (error) {
      lastError = error;
      if (error?.message?.includes('storage.objects.')) throw error;
    }
  }

  if (!response) throw lastError || new Error('Unable to load call recordings.');

  const data = await response.json();
  const apiBase = new URL(response.url).origin;

  return {
    ...data,
    recordings: (data.recordings || []).map((recording) => ({
      ...recording,
      content_url: buildContentUrl(apiBase, recordId, recording),
    })),
  };
};
